import { CreateSpineResources, Safe, Scale, Size } from "../../../MyHelpers";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { Resourceful } from "../../../ResourceManager/Resourceful";
import * as PIXI from "pixi.js";
import { Settings } from "../../../Settings";
import { JSONResource } from "../../../ResourceManager/JSONResource";
import { AtlasResource } from "../../../ResourceManager/AtlasResource";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { ISkeletonData, Spine } from "pixi-spine";
import gsap from "gsap";
import { JackpotProperties } from "../../../JackpotProperties";
import { children, element } from "svelte/internal";
import { JackpotLevel } from "../../../api";
import { el } from "date-fns/locale";
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../../../singlegame/ResponsiveHelpers";

export class AwardJPShowElemntPIXAPP {

    protected award: Spine = null;
    protected spinSpineJson: ISkeletonData = null;
    protected viewPIXIAPP : PIXI.Container = null;  
    protected animBigFallingAwards: gsap.core.Timeline = null;
    protected animSmallFallingAwards: gsap.core.Timeline = null;
    constructor(spinSpineJson: ISkeletonData){
        this.spinSpineJson = spinSpineJson;       
    }

    public ViewPIXIAPP(){
        return this.viewPIXIAPP
    }

    protected awardDimmondSpine : Spine [] = []
    public CreatePIXIAPP() {
        this.awardDimmondSpine = [];
        this.viewPIXIAPP = new PIXI.Container();
        this.viewPIXIAPP.name = "AwardJPShowElementsContainerPIXIAPP";
        //let sizeSpine = new Size(0,0);
        for (var i = 0; i < 100; i++) {
            let award = CreateSpineResources(this.spinSpineJson);
            //award.state.setAnimation(0, "animation", true);                                    
            //award.tint = new PIXI.Color( JackpotProperties[Settings.JackpotDisplayType].jp3.color).toNumber();
            award.x = Math.random() * (Settings.ScreenWidth);
            award.y = Math.random() * ((Settings.ScreenHeight) * Settings.Screens);
            //award.alpha = Math.random() * 0.5 + 0.5;
            let scale = Math.random() * 0.5 + 0.5
            award.scale.set(Scale.XY(scale));
          
            award.pivot.set(award.width/2 , award.height/2);
            // Generate a random angle between 45 and 135 degrees
            var angle = Math.floor(Math.random() * (135 - 45 + 1 )) + 45 * -1;
            // Set the animation object's rotation to the random angle
            award.rotation = angle * Math.PI / 180;
            this.viewPIXIAPP.addChild(award);     
            this.awardDimmondSpine.push(award);   
            award.state.timeScale = scale;
        }


        let smallAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x < 0.7);
        let bigAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x > 0.7);

        // Animate the rain sprites using GSAP

        this.animSmallFallingAwards = gsap.timeline({ paused: true});

        this.animSmallFallingAwards.add(gsap.to(smallAwardScale, {
            duration: 25,
            ease: "none",
            y: "+=" + (Settings.ScreenHeight * Settings.Screens),
            modifiers: {
                y: function (y) {
                    return y % -(Settings.ScreenHeight * Settings.Screens);
                },
            },
            repeat: -1,
        }));


        this.animBigFallingAwards = gsap.timeline({ paused: true});
        // // Animate the rain sprites using GSAP
        this.animBigFallingAwards.add(gsap.to(bigAwardScale, {
            duration: 5,
            ease: "none",
            y: "+=" + (Settings.ScreenHeight * Settings.Screens),
            modifiers: {
                y: function (y) {
                    return y % -(Settings.ScreenHeight * Settings.Screens);
                },
            },
            repeat: -1,
        }));
    }

    public SetSkin(jp: JackpotLevel) {
        this.awardDimmondSpine.forEach(element => {
            let lowerSideTextrues = element.children.filter(elementchild => {
                if (elementchild.name.includes("lower-side") || elementchild.name.includes("upper-side") || elementchild.name.includes("top")) return elementchild
                return null;
            });

            lowerSideTextrues.forEach(ele => {
                let color = new PIXI.Color(JackpotProperties[Settings.JackpotDisplayType][jp].color).toRgb();
                (element as Spine).skeleton.findSlot(ele.name).color.set(color.r, color.g, color.b, 1);
            });
        })
    }

    public Destroy(){
        Safe(()=>{
            this.viewPIXIAPP.destroy({children : true});
            this.awardDimmondSpine.forEach(element=>element.destroy({children : true}))
            //this.awardDimmondSpine = [];
            this.animSmallFallingAwards = null;
            this.animBigFallingAwards = null;
        })
    }

    public StartAnim(){
        this.awardDimmondSpine?.forEach(element=>{
            element.state.setAnimation(0, "animation", true);
            element.state.setAnimation(1, "animationSparks", true);                                        
        });
        this.animBigFallingAwards?.play(); 
        this.animSmallFallingAwards?.play();     
    }

    public StopAnim(){        
        this.animSmallFallingAwards?.pause();    
        this.animBigFallingAwards?.pause();  
    }   

    public RepositionDiamonds(width: number, height: number) {
        this.awardDimmondSpine?.forEach(award => {
            award.x = Math.random() * width;
            award.y = Math.random() * height;
        });
    }
}


export class AwardJPShowPIXAPP implements Resourceful {
    protected viewPIXIAPP : PIXI.Container = null;    
    constructor() {        
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine`; 
		//preload spine 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/AwardJPSPine/AwardJPSPine.json`, ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/AwardJPSPine/AwardJPSPine.atlas`, ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineATLAS`)));
    }

    protected awardElements : AwardJPShowElemntPIXAPP = null;

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {  
        let bonusTitleSpineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineJson`));
		let bonusTitleSpine = await PIXI.Assets.load(bonusTitleSpineTextureJson.path);
		//this.AwardJPSPineJson = bonusTitleSpine.spineData;

        this.awardElements = new AwardJPShowElemntPIXAPP(bonusTitleSpine.spineData);
    }

    public CreatePIXIAPP(){
        this.viewPIXIAPP = new PIXI.Container();
        
        this.viewPIXIAPP.name = "AwardJPShowContainerPIXIAPP";
        this.viewPIXIAPP.visible = false;
        let textureBackagroundContainer = new PIXI.Sprite(PIXI.Texture.WHITE);
        textureBackagroundContainer.width = Settings.ScreenWidth;
        textureBackagroundContainer.height = Settings.ScreenHeight * Settings.Screens;
        textureBackagroundContainer.tint = "black";
        this.viewPIXIAPP.addChild(textureBackagroundContainer);
        this.awardElements.CreatePIXIAPP();
        this.viewPIXIAPP.addChild(this.awardElements.ViewPIXIAPP());        
    }

    public ViewPIXIAPP() : PIXI.Container{
        return this.viewPIXIAPP;
    }
    
    public SetSkin(jp: JackpotLevel){
        this.awardElements?.SetSkin(jp);
    }

    public Destroy(){
        Safe(()=>{
            this.viewPIXIAPP.destroy({children : true});                       
        });
        Safe(()=>{
            this.awardElements?.Destroy();                       
        })
    }

    public StarAnim(){
        this.awardElements?.StartAnim();
    }
    
    public StopAnin(){
        this.awardElements?.StopAnim();
    }
}
